import { Action } from 'redux';
import { NlpSetting } from '../../ts/models/IDataSourceInfo';
import { SetNlpSetting } from './AppActionTypes';

export interface SetNlpSettingAction extends Action {
  nlpSetting: NlpSetting;
  feedbackToCurator: boolean;
}

export const setNlpSetting = (nlpSetting: NlpSetting, feedbackToCurator: boolean): SetNlpSettingAction => ({
  type: SetNlpSetting,
  nlpSetting,
  feedbackToCurator,
});
